
export default {
  data() {
    return {
      title: '',
      images: [],
      loading: [],
      error: [],
      open: false,
      slide: 0,
    };
  },
  computed: {
    carouselProps() {
      return this.images.length > 1 ? {controls: true, indicators: true} : {};
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClicksOutsideComponent);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClicksOutsideComponent);
  },
  methods: {
    openImages(images, title = '', slide = 0) {
      if (!Array.isArray(images) || !images.length || !images.every(this.isValidImage)) {
        console.error('Parameter images must be a non-empty array of {id, alt, url, thumbnailUrl} objects.');

        return;
      }
      if (!Number.isInteger(slide) || slide < 0 || slide > images.length - 1) {
        console.error(`Parameter slide must be an integer between 0 and number of images - 1.`);

        return;
      }

      this.title = title;
      this.images = images;
      this.slide = slide;
      this.loading = Array(images.length).fill(true);
      this.error = Array(images.length).fill(false);
      this.open = true;
    },
    onImageError(index) {
      this.loading[index] = false;
      this.error[index] = true;
    },
    isValidImage(value) {
      return typeof value === 'object'
        && value !== null
        && Number.isInteger(value.id)
        && typeof value.alt === 'string'
        && typeof value.url === 'string';
    },
    handleClicksOutsideComponent(event) {
      const triggerButton = event.target;
      if (!triggerButton.classList.contains('trigger-image-viewer')) return;

      const images = triggerButton.dataset.images ? JSON.parse(triggerButton.dataset.images) : [];
      const title = triggerButton.dataset.title ?? '';
      const slide = triggerButton.dataset.slide ? JSON.parse(triggerButton.dataset.slide) : 0;

      this.openImages(images, title, slide);
    },
  },
}
